import { render, staticRenderFns } from "./uploadAPPGroup.vue?vue&type=template&id=6b6778e0&"
import script from "./uploadAPPGroup.vue?vue&type=script&lang=js&"
export * from "./uploadAPPGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports